import { render, staticRenderFns } from "./AppGlobalLoader.vue?vue&type=template&id=705cdbf2&scoped=true"
import script from "./AppGlobalLoader.vue?vue&type=script&lang=ts"
export * from "./AppGlobalLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705cdbf2",
  null
  
)

export default component.exports